import axios from "axios";

const loginedApi = axios.create({


     baseURL: "https://www.connect2mydoctor.com/c2mydrrestgericare/v1/c2mdapi/",
  //baseURL: "https://uat.c2mdr.com/c2mydrrestrevamp/v1/c2mdapi/", //changed for uat
   //baseURL: "https://uat.c2mdr.com/c2mydrrestrevamp/v1/c2mdapi/", //changed for interbranch
  timeout: 1500000, // Set timeout to 15 seconds (in milliseconds)
  //  baseURL: "https://www.connect2mydoctor.ae/c2mydrrestrevamp/v1/c2mdapi/",
  // baseURL: "http://localhost:8080/c2mydrrestuat/v1/c2mdapi"
});

// Add a request interceptor
loginedApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
/*loginedApi.interceptors.response.use(
   (response) => response,
   async (error) => {
     const originalRequest = error.config;

//     // If the error status is 401 and there is no originalRequest._retry flag,
//     // it means the token has expired and we need to refresh it
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
         const refreshToken = localStorage.getItem('refreshToken');
         const response = await axios.post('/api/refresh-token', { refreshToken });
         const { token } = response.data;

         localStorage.setItem('token', token);

        // Retry the original request with the new token
         originalRequest.headers.Authorization = `Bearer ${token}`;
         return axios(originalRequest);
      } catch (error) {
         // Handle refresh token error or redirect to login
      }
     }

    return Promise.reject(error);
   }
 );*/

export default loginedApi;


export const misapi = axios.create({


  baseURL: "https://www.connect2mydoctor.com/c2mydrrestgericare/v1/c2mdapi/",
//baseURL: "https://uat.c2mdr.com/c2mydrrestdemo/v1/c2mdapi/", //changed for uat
//baseURL: "https://uat.c2mdr.com/c2mydrrestrevamp/v1/c2mdapi/", //changed for interbranch
timeout: 1500000, // Set timeout to 15 seconds (in milliseconds)
//  baseURL: "https://www.connect2mydoctor.ae/c2mydrrestrevamp/v1/c2mdapi/",
// baseURL: "http://localhost:8080/c2mydrrestuat/v1/c2mdapi"
});

// export const SERVER_API_URL = "http://localhost:8080/c2mydrrestuat/v1/c2mdapi"


 //export const SERVER_API_URL ="https://uat.c2mdr.com/c2mydrrestrevamp/v1/c2mdapi/"; //changed for uat
//export const SERVER_API_URL ="https://uat.c2mdr.com/c2mydrrestrevamp/v1/c2mdapi/";
export const SERVER_API_URL =  "https://www.connect2mydoctor.com/c2mydrrestgericare/v1/c2mdapi/";

export const REPORT_API_URL =  "https://www.connect2mydoctor.com/admindemorest/v1/c2mdapi/";

// export const SERVER_API_URL =  "https://www.connect2mydoctor.ae/c2mydrrestrevamp/v1/c2mdapi/";//dubai
export const TestingUrl = "https://zoom.us/test";
//export const TestingUrl = "https://www.connect2mydoctor.com/testcomputer.html";
//export const FILEURL = "https://uat.c2mdr.com/demo/Connect2MyDoctorRequest";
export const FILEURL =  "https://www.connect2mydoctor.com/Connect2MyDoctorRequest";
export const c2mdApi = axios.create({
  //baseURL: "https://uat.c2mdr.com/c2mydrrestrevamp/v1/c2mdapi/", //changed for interbranch
  // baseURL: "https://www.connect2mydoctor.ae/c2mydrrestrevamp/v1/c2mdapi/",

  //baseURL: "https://uat.c2mdr.com/c2mydrrestrevamp/v1/c2mdapi/", //changed for demo
  baseURL: "https://www.connect2mydoctor.com/c2mydrrestgericare/v1/c2mdapi/",


});

export const c2mdApinew = axios.create({
  baseURL: "http://localhost:8080/ROOT/",
});
